import { createStore, applyMiddleware, compose } from 'redux'
import thunk from 'redux-thunk'
import createRootReducer, { middleware } from './createRootReducer'

// Create the application store with redux.
// Redux uses `reducers` to allow different types of dispatched
// actions to mutate global state in one place.
// All actions should be dispatched and go
// through the reducers of the application store.
// See more on redux here:
// * http://redux.js.org/
// * https://egghead.io/series/getting-started-with-redux
// * https://egghead.io/series/building-react-applications-with-idiomatic-redux
//
// The redux-thunk middleware allows dispatched actions to work
// asynchronously by returning a function instead of new state
// See more on redux-thunk here:
// * https://github.com/gaearon/redux-thunk
const createApplicationStore = () => {
    let rootReducer = createRootReducer()

    // redux thunk allows redux actions to be defined as a function that accepts
    // dispatch as an argument, this allows actions to be async
    return createStore(rootReducer, compose(
        applyMiddleware(...[
            thunk,
            middleware,
        ]),
        window.devToolsExtension ? window.devToolsExtension() : (f) => f
    ))
}

export default createApplicationStore



// WEBPACK FOOTER //
// ./src/store/createApplicationStore.js